import React, { useEffect } from "react";

const Review = () => {
  useEffect(() => {
    // Load Elfsight platform script once
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Keep checking every second for Elfsight links, remove them once found
    const interval = setInterval(() => {
      const brandingLinks = document.querySelectorAll(
        'a[href*="elfsight.com"]'
      );
      if (brandingLinks.length > 0) {
        brandingLinks.forEach((el) => el.remove());
        clearInterval(interval); // stop checking after removing
      }
    }, 1000);

    // Cleanup on unmount
    return () => {
      clearInterval(interval);
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="mt-16">
      <div className="max-w-xxl mx-auto px-4 py-8">
        <div
          className="elfsight-app-2cb6c7f2-dcba-4dec-b130-8665f8f232b2"
          data-elfsight-app-lazy
        ></div>
      </div>
    </div>
  );
};

export default Review;
